import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { Jumbo } from "../components/jumbo";
export class NewsletterSignupPage extends React.Component {
    componentDidMount() {
        document.title = this.props.pageTitle;
    }
    render() {
        const p = this.props;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Jumbo, {
                    title: p.headerTitle,
                    contents: p.description,
                    imageUrl: p.phImageUrl,
                    imageUrlFallback: p.phImageUrlFallback,
                    imageUrlLarge: p.phImageUrlLarge,
                    imageAlt: p.imageAlt,
                    size: "small"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "container--mg align--center",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "newsletter",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "newsletter__container container--s align--center",
                            children: /*#__PURE__*/ _jsx("iframe", {
                                width: 960,
                                height: 830,
                                src: "https://app.hellodialog.com/subscribe/91a3cdb6a94b8ce97f50c20d",
                                title: "Aanmeldformulier voor nieuwsbrief"
                            })
                        })
                    })
                })
            ]
        });
    }
}
{}